/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"

import _ from 'lodash'

import styled, { createGlobalStyle } from "styled-components"

import { useRanger } from "react-ranger"

import { 
    Tooltip,
} from '@material-ui/core'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import LABEL from '../../../business-const/Label/Label'



const GlobalStyles = createGlobalStyle`
    body {
      font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
      font-weight: 300;
    }
`

export const Track = styled("div")`
    display: inline-block;
    height: 8px;
    width: 99%;
    margin: 0 0%;
`

export const Tick = styled("div")`
    :before {
        content: "";
        position: absolute;
        left: 0;
        background: rgba(0, 0, 0, 0.2);
        height: 5px;
        width: 2px;
        transform: translate(-50%, 0.7rem);
    }
`

export const TickLabel = styled("div")`
    position: absolute;
    font-size: 0.6rem;
    color: rgba(0, 0, 0, 0.5);
    top: 100%;
    transform: translate(-50%, 1.2rem);
    white-space: nowrap;
`

export const Segment = styled("div")`
    background: ${props =>
        props.index === 0
            ? "#01ABAA"//"#49274A"//"#94618E"//"#008F95"//"#E57D90"//"#75B3A4"//"#5A978E"//"#00d5c0"//"#ff6050"//"#00EDF7"//"#B4EBD3"//"#00ee00"//"#4c9fff"//"#3e8aff"
            : props.index === 1
            ? "#008000"//"#0c8b2e"//"#10b33b"//"#12C742"//"#304D63"//"#8FB9AA"//"#00C7D0"//"#75B3A4"//"#008800"//"#00d5c0"
            : props.index === 2
            ? COLOR().corChartPadraoConsumirReservaManterPadraoVida//"#f5c200"//"#00A2A9"//"#427C79"//"#aa0022"//"#f7cd65"//"#f5c200"
            : COLOR().corChartPadraoManterReservaManterPadraoVida//"#3e8aff"//"#007C81"//"#1D3E44"//"#880000"//"#e7745f"//"#ff6050"
    };
    height: 100%;
`

export const Handle = styled("div")`
    background: ${props => (props.value === props.idades[0] ? "gray" : "#ff1a6b")};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 100%;
    font-size: 0.7rem;
    white-space: nowrap;
    color: white;
    font-weight: ${props => (props.active ? "bold" : "normal")};
    transform: ${props =>
      props.active ? "translateY(-100%) scale(1.3)" : "translateY(0) scale(0.9)"};
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`


export const AposentadoriaExpectativaVida = ( {values, setValues, idades, handleChange } ) => {

    const { getTrackProps, ticks, segments, handles } = useRanger({
        min: 0,
        max: 120,
        stepSize: 1,
        values,
        onChange: setValues
    })

    if (!_.isEqual(values, idades)) {

      handleChange(values)
    }

    return (
        <div
            className="App"
            style={{
                height: '50px'
            }}
        >
            <GlobalStyles />

            <Track
                {...getTrackProps()}
            >
                {ticks.map(({ value, getTickProps }) => (
                    <Tick {...getTickProps()}>
                        <TickLabel>
                            {value}
                        </TickLabel>
                    </Tick>
                ))}

                {segments.map(({ getSegmentProps }, i) => (
                    <Segment
                        {...getSegmentProps()}
                        index={i}
                    />
                ))}

                {handles.map(({ value, active, getHandleProps }, ind) => (
                    <Tooltip
                        key={ind}
                        title={[LABEL.idadeDataSimulacao, LABEL.idadeVaiAposentar, LABEL.idadeExpectativaVida][ind]}
                    >
                        <button
                            {...getHandleProps({
                                style: {
                                    appearance: "none",
                                    border: "none",
                                    background: "transparent",
                                    outline: "none"
                                }
                            })}
                        >
                            <Handle
                                active={active}
                                value={value}
                                idades={idades}
                            >
                                {value}
                            </Handle>
                        </button>
                    </Tooltip>
                ))}
            </Track>
        </div>
    )
}